var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { RadioGroup } from '@headlessui/react';
import mergeClassnames from '../mergeClassnames/mergeClassnames';
const RadioRoot = forwardRef((_a, ref) => {
    var { defaultValue, value, onChange, children, className, disabled, name } = _a, rest = __rest(_a, ["defaultValue", "value", "onChange", "children", "className", "disabled", "name"]);
    return (React.createElement(RadioGroup, Object.assign({ ref: ref, defaultValue: defaultValue, value: value, onChange: onChange, className: className, disabled: disabled, name: name }, rest), children));
});
const Option = ({ value, children, className, disabled }) => {
    const ariaLabelValue = value ? value.toString() : 'Radio option';
    return (React.createElement(RadioGroup.Option, { value: value, disabled: disabled, className: mergeClassnames('flex gap-2 cursor-pointer text-moon-14 text-bulma moon-disabled:opacity-60', 'moon-disabled:cursor-default', className), "aria-label": ariaLabelValue }, children));
};
const Indicator = ({ className }) => (React.createElement("div", { className: mergeClassnames('relative flex items-center justify-center w-4 h-4 aspect-square m-1 rounded-full border', 'transition-colors after:absolute after:w-0 after:h-0 after:rounded-full after:top-1/2', 'after:left-1/2 after:-translate-x-1/2 after:-translate-y-1/2 after:transition-all', 'moon-checked:after:w-2 moon-checked:after:h-2 border-trunks moon-checked:border-piccolo', 'after:bg-piccolo', className) }));
const Radio = Object.assign(RadioRoot, { Option, Indicator });
export default Radio;
